"use client";

import React from 'react';
import Image from 'next/image';
import { useLanguage } from '@/context/LanguageContext';

export default function Footer() {
  const { t } = useLanguage();
  const currentYear = 2026;

  const footerLinks = [
    { label: t('nav_services'), href: '#services' },
    { label: t('nav_ai_agents'), href: '#ai-agents' },
    { label: t('nav_process'), href: '#process' },
    { label: t('footer_contact_label'), href: '#contact' },
    { label: t('footer_privacy'), href: '#' },
    { label: t('footer_terms'), href: '#' },
  ];

  return (
    <footer className="border-t border-[rgba(139,158,192,0.1)] bg-[#060D1A]">
      <div className="max-w-container mx-auto px-6 py-10 flex flex-col md:flex-row items-center justify-between gap-6">
        {/* Logo + Copyright */}
        <div className="flex items-center gap-4">
          <Image
            src="/assets/images/positivo---color-1773188764124.png"
            alt="Devros AI Logo"
            width={240}
            height={80}
            className="object-contain h-10 sm:h-12 md:h-16 w-auto footer-logo"
          />
          <span className="text-sm font-medium text-muted">
            {t('footer_copyright')?.replace('2026', String(currentYear))}
          </span>
        </div>

        {/* Links */}
        <nav className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
          {footerLinks?.map((link) => (
            <a
              key={link?.label}
              href={link?.href}
              className="text-[14px] font-medium text-muted hover:text-white transition-colors"
            >
              {link?.label}
            </a>
          ))}
        </nav>

        {/* Social + Contact */}
        <div className="flex items-center gap-5">
          <a
            href="mailto:contact@devros.ai"
            className="text-[14px] font-medium text-muted hover:text-primary transition-colors"
          >
            contact@devros.ai
          </a>
          {/* LinkedIn */}
          <a
            href="#"
            className="w-9 h-9 rounded-lg border border-[rgba(139,158,192,0.2)] flex items-center justify-center text-muted hover:text-primary hover:border-primary transition-all"
            aria-label="LinkedIn"
          >
            <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
              <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
            </svg>
          </a>
          {/* Twitter/X */}
          <a
            href="#"
            className="w-9 h-9 rounded-lg border border-[rgba(139,158,192,0.2)] flex items-center justify-center text-muted hover:text-primary hover:border-primary transition-all"
            aria-label="Twitter"
          >
            <svg width="15" height="15" fill="currentColor" viewBox="0 0 24 24">
              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.747l7.73-8.835L1.254 2.25H8.08l4.253 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
            </svg>
          </a>
        </div>
      </div>
    </footer>
  );
}